@import "~/styles/variables";
@import "~/shared/inputs/__styles__/Inputs.scss";

.Inputster {
  align-items: center;
  cursor: pointer;
  display: flex;

  &.isDisabled {
    cursor: default;
  }
}

.Inner {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
}

.Placeholder {
  @include input-placeholder;

  &:hover {
    @include input-placeholder;
  }
}
